import script from "./SideBarPlanList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideBarPlanList.vue?vue&type=script&setup=true&lang=ts"

import "./SideBarPlanList.vue?vue&type=style&index=0&id=6821ec4f&lang=scss"

const __exports__ = script;

export default __exports__